import Vue from 'vue';
import Loading from 'element-ui/lib/loading';

import './loading.scss';

// to setup the v-loading directive
Vue.use(Loading);

export default Loading;
